// removed by extract-text-webpack-plugin
module.exports = {"location":"location_location_2OyZJ","title":"location_title_KsirO","list":"location_list_2vhHj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/common/location/location.scss
// module id = 1539
// module chunks = 0